module.exports = new __parcel__URL__("meteo.20ddaefd.svg").toString();